import styled from 'styled-components'

export const Container = styled.div``
export const List = styled.ul`
  display: flex;
  flex-flow: row wrap;
  margin: 0 -0.3rem;
  list-style: none outside;
  & > li {
    margin: 0.3rem;
  }
`
